<script>
import { mapGetters } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import navMixin from '@/mixins/navMixin'
import { LogoShade } from '@/shared/constants/assets/LogoShade'

export default {
  name: 'TheNavLinks',
  mixins: [baseMixin, navMixin],
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
    }),
    isMini() {
      return !this.isMobileViewPort && this.mini
    },
    compShade() {
      return this.isDarkMode ? LogoShade.LIGHT : LogoShade.DARK
    },
  },
}
</script>

<template>
  <v-list
    flat
    :class="[
      isMobileViewPort ? 'mini-sidebar-nav pa-4' : 'sidebar-nav',
      colorClass.text.primary,
    ]"
    :style="!isMobileViewPort && !isMini ? 'padding:0 16px;' : ''"
  >
    <div v-for="{ icon, title, to, key } in navItems" :key="key">
      <!-- desktop view with tooltip -->
      <v-tooltip v-if="!isMobileViewPort" :disabled="!isMini" right>
        <template v-slot:activator="{ on }">
          <v-list-item
            :to="to"
            :aria-label="title"
            exact
            link
            :color="colorClass.primary"
            :class="[
              'hover-bg-color',
              isMini && 'mini-hover mini-item',
              isActiveNavItem(to) && 'nav-active',
            ]"
            :style="!isMini ? 'gap:10px;' : ''"
            v-on="on"
          >
            <v-list-item-icon>
              <BaseIcon :name="icon" :shade="compShade" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :class="textClass.smallBodyBold">
                {{ title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ title }}</span>
      </v-tooltip>

      <!-- mobile view without tooltip -->
      <v-list-item
        v-else
        :to="to"
        :aria-label="title"
        exact
        link
        :color="colorClass.primary"
        :class="['hover-bg-color', isActiveNavItem(to) && 'nav-active']"
      >
        <v-list-item-icon>
          <BaseIcon
            size="20"
            :color="isActiveNavItem(to) ? colorClass.blue : ''"
            :name="icon"
          />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title :class="textClass.smallBodyBold">
            {{ title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-list>
</template>

<style lang="scss" scoped>
@import '@styles';
@import '@/styles/nav-drawer.scss';
</style>
